import * as A7ProductsAction from "./A7ProductsAction";

export default function a7ProductsReducer(state = {}, action) {
    switch (action.type) {
        case A7ProductsAction.REQUEST_PRODUCTS_FINISHED:
            if (action.payload.errors) {
                return {
                    ...state
                };
            } else {
                return {
                    ...state,
                    ...action.payload
                };
            }
        default:
            return state;
    }
}
